import { ref } from 'vue'

export function useTempoTap() {
  const taps: number[] = []
  const bpm = ref<number | null>(null)
  const isActive = ref(false)
  let resetTimeout: NodeJS.Timeout | null = null

  const tap = () => {
    const now = Date.now()
    isActive.value = true

    // Reset if it's been more than 2 seconds since last tap
    if (taps.length > 0 && now - taps[taps.length - 1] > 2000) {
      taps.length = 0
    }

    taps.push(now)

    // Keep only the last 4 taps for averaging
    if (taps.length > 4) {
      taps.shift()
    }

    // Calculate BPM if we have at least 2 taps
    if (taps.length >= 2) {
      const intervals = []
      for (let i = 1; i < taps.length; i++) {
        intervals.push(taps[i] - taps[i - 1])
      }

      const averageInterval = intervals.reduce((a, b) => a + b, 0) / intervals.length
      bpm.value = Math.round(60000 / averageInterval) // Convert to BPM (60000ms / average interval)
    }

    // Reset active state after 2 seconds of inactivity
    if (resetTimeout) {
      clearTimeout(resetTimeout)
    }
    resetTimeout = setTimeout(() => {
      isActive.value = false
      taps.length = 0
    }, 2000)
  }

  return {
    tap,
    bpm,
    isActive,
  }
}
